import Chip, { ChipColor } from 'web-common/src/shared/design-system/components/Chip';
import { Icon } from 'web-common/src/shared/design-system/components/Icon';

const TasteTestedChip: React.FC = () => {
  const checkIcon = <Icon name='verifiedCheck' size={16} />;
  return (
    <Chip fontWeight='bold' iconFittedContainer color={ChipColor.NEUTRAL_50} copy='Taste Tested' icon={checkIcon} />
  );
};

export default TasteTestedChip;
